import { render, staticRenderFns } from "./ManageAdmins.vue?vue&type=template&id=b0a7f490&scoped=true&"
import script from "./ManageAdmins.vue?vue&type=script&lang=js&"
export * from "./ManageAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a7f490",
  null
  
)

export default component.exports